<script>
	import { user, token } from "../store";
    import { _ } from 'svelte-i18n';

    import { 
        Collapse,
		Dropdown,
		DropdownToggle,
		DropdownMenu,
		DropdownItem,
		Icon,
        Nav,
        Navbar,
        NavbarBrand,
		NavLink,
        NavbarToggler,
        NavItem
    } from "sveltestrap";

    let isOpen = false;

    function handleUpdate(event) {
        isOpen = event.detail.isOpen;
    }

	import Alerts from "./Alerts.svelte";
	export let showAlert = false;
</script>

<Navbar color="success" dark expand="md" class="fixed-top" id="menu">
	<NavbarBrand href="/">
		<img src="/img/logo.png" width="70px" alt="Oxalt" />
	</NavbarBrand>
	<NavbarToggler on:click={() => (isOpen = !isOpen)} />
	<Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>
		<Nav class="pe-5 ms-auto" navbar>
			<NavItem>
				<a href="/profile/" class="nav-link">
					<Icon name="person-fill" /> {$user.name}
				</a>
			</NavItem>
			<Dropdown setActiveFromChild>
				<DropdownToggle nav><Icon name="gear" /></DropdownToggle>
				<DropdownMenu end class="dropdown-menu-dark">
					<DropdownItem>
						<a href="/params/" class="nav-link">
							{$_("components.Menu.param")}
						</a>
					</DropdownItem>
					<DropdownItem>
						<a href="/profile/" class="nav-link">
							{$_("components.Menu.profil")}
						</a>
					</DropdownItem>
					<DropdownItem divider />
					<li>
						<a class="dropdown-item" href="/Logout/{$token}/" replace="true">
							{$_("components.Menu.logout")}
						</a>
					</li>
				</DropdownMenu>
			</Dropdown>
		</Nav>
	</Collapse>
</Navbar>
<Navbar>
	<NavbarBrand>Oxalt</NavbarBrand>
</Navbar>

{#if !showAlert}
	<Alerts />
{/if}